<template>
  <div class="login">
    <el-card>
        <img src="@/img/apc_head_logo.svg" class="app-logo"/>
        <!--ログイン画面-->
        <div v-if="mode === 'login'">
            <el-form class="login-form" :model="model" :rules="rules" ref="loginForm" @submit.native.prevent="login">
                <el-form-item prop="userid">
                  <el-input v-model="model.userid" placeholder="UserID" prefix-icon="el-icon-user-solid"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input v-model="model.password" placeholder="Password" type="password" prefix-icon="el-icon-key" show-password></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button :loading="loading" class="form-button" type="primary" native-type="submit" block>ログイン</el-button>
                </el-form-item>
                <el-link type="primary" @click="changeMode('forgot', 'loginForm')">パスワード変更または再設定</el-link>
            </el-form>
        </div>
        
        <!--パスワード再設定用メール送信-->
        <div v-if="mode === 'forgot'">
            <el-form class="login-form" :model="model" :rules="rules" ref="forgotForm" @submit.native.prevent="sendCode">
                パスワード再設定
                <el-form-item prop="userid">
                    <el-input v-model="model.userid" placeholder="UserID" prefix-icon="el-icon-user-solid"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="loading" class="form-button" type="primary" native-type="submit">再設定コードを送信</el-button>
                </el-form-item>
              </el-form>
            <el-link type="primary" @click="changeMode('login', 'forgotForm')">戻る</el-link>
        </div>

        <!--パスワード再設定-->
        <div v-if="mode === 'change_password'">
            <el-form class="login-form" :model="model" :rules="rules" ref="changePasswordForm" @submit.native.prevent="changePassword">
                パスワード再設定
                <el-form-item prop="userid">
                  <el-input v-model="model.userid" placeholder="UserID"></el-input>
                </el-form-item>
                <el-form-item prop="reset_code">
                    <el-input v-model="model.reset_code" placeholder="Reset Code"></el-input>
                </el-form-item>
                <el-form-item prop="new_password">
                    <el-input v-model="model.new_password" placeholder="New Password" type="password" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="loading" class="form-button" type="primary" native-type="submit">変更</el-button>
                </el-form-item>
            </el-form>
            <el-link type="primary" @click="changeMode('forgot', 'changePasswordForm')">戻る</el-link>
        </div>

        <!--初回ログイン時のパスワード変更-->
        <div v-if="mode === 'first_login'">
            <el-form class="login-form" :model="model" :rules="rules" ref="firstLoginForm" @submit.native.prevent="firstLogin">
                パスワードを変更してください。
                <el-form-item prop="new_password">
                  <el-input v-model="model.new_password" placeholder="New Password" type="password" show-password></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button :loading="loading" class="form-button" type="primary" native-type="submit">変更</el-button>
                </el-form-item>
                <el-link type="primary" @click="changeMode('login', 'firstLoginForm')">戻る</el-link>
            </el-form>
        </div>
        
        <el-row type="flex" justify="end" class="card-footer">
          <img src="@/img/logo_footer.png" />
        </el-row>
    </el-card>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'

export default {
  name: "login",
  data() {
    return {
        mode: "login",
        user: undefined,
        model: {
            userid: "",
            password: "",
            reset_code:"",
            new_password: ""
        },
        loading: false,
        rules: {
            userid: [
              {required: true, message: "ユーザーIDは必須です", trigger: "blur"},
            ],
            password: [
              { required: true, message: "パスワードは必須です", trigger: "blur" },
            ],
            reset_code: [
              { required: true, message: "リセット用コードは必須です", trigger: "blur" }
            ],
            new_password: [
              { required: true, message: "パスワードは必須です", trigger: "blur" },
              { min: 8, message: "パスワードは8文字以上で設定してください", trigger: "blur"},
              { max: 256, message: "パスワードは256文字以内で設定してください", trigger: "blur"},
              { pattern:"(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\\d)[a-zA-Z\\d]{8,}", message:"パスワードは半角英小文字, 大文字, 数字から各1つ以上必要です", trigger: "blur"}
            ]
        }
    };
  },
  methods: {
    async changeMode(mode, formName){
        // mode:
        //   login: ログイン画面
        //   forgot: パスワード再設定コード送信画面
        //   change_password: パスワード再設定画面
        //   first_login: 初回ログイン時パスワード変更画面
        this.mode = mode;
        this.$refs[formName].resetFields()
        this.user = undefined
    },
      
    // ログイン
    async login() {
      let valid = await this.$refs['loginForm'].validate();
      if (!valid) {
        return;
      }
      try{
        this.loading = true;
        const user = await Auth.signIn(this.model.userid, this.model.password);
        if (user && user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            //初回ログイン時（要パスワード変更）
            this.changeMode('first_login', 'loginForm')
            this.user = user
        }else if(user){
            //ログイン成功時
            AmplifyEventBus.$emit('authState', 'signedIn')
        }else{
            //ログイン失敗時
            this.$message.error("ユーザー名またはパスワードがちがいます");
        }
      }catch(error){
            if(error.code==='UserNotFoundException' || error.code==='NotAuthorizedException'){
                this.$message.error("ユーザー名またはパスワードがちがいます");
            }else{
                this.$message.error('エラーが発生しました')
            }
      }finally{
        this.loading = false;
      }
    },
    
    //パスワード再設定用メール送信
    async sendCode() {
        let valid = await this.$refs['forgotForm'].validate();
        if (!valid) {
            return;
        }
        this.loading = true;
        Auth.forgotPassword(this.model.userid)
            .then(data => {
                this.$message.success('ご登録のメールアドレスに再設定用のコードを送信しました。')
                this.changeMode('change_password', 'forgtForm')
                console.log(data)
            })
            .catch(err => {
                console.log(err)
                if(err.code==='LimitExceededException'){
                    this.$message.error("上限回数に達しました。しばらく待ってから再度お試しください");
                }else if(err.code==='UserNotFoundException'){
                    this.$message.error("ユーザーIDが見つかりませんでした");
                }else{
                    this.$message.error('エラーが発生しました')
                }
            });
        this.loading = false;
    },

    //パスワード再設定
    async changePassword() {
        let valid = await this.$refs['changePasswordForm'].validate();
        if (!valid) {
            return;
        }
        this.loading = true;
        Auth.forgotPasswordSubmit(this.model.userid, this.model.reset_code, this.model.new_password)
            .then(data => {
                console.log(data)
                this.$message.success('パスワードを変更しました')
                this.changeMode('login', 'changePasswordForm')
            })
            .catch(err => {
                console.log(err)
                if(err.code==='CodeMismatchException'){
                    this.$message.error("リセットコードがちがいます");
                }else if(err.code==='LimitExceededException'){
                    this.$message.error("上限回数に達しました。しばらく待ってから再度お試しください");
                }else if(err.code==='ExpiredCodeException'){
                    this.$message.error("リセットコードの期限が切れました。再度発行の上お試しください");
                }else{
                    this.$message.error('エラーが発生しました')
                }
            });
        this.loading = false;
    },
    
    // 初回ログイン
    async firstLogin() {
        Auth.completeNewPassword(this.user, this.model.new_password)
        .then(user => {
            //ログイン成功時
            if(user){
                console.log(user)
                AmplifyEventBus.$emit('authState', 'signedIn')
            }
        }).catch(e => {
            // TODO error
            console.log(e);
            this.$message.error('エラーが発生しました')
        });
    },

  }

    
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app-logo{
    height: 40px;
    width: 280px;
    margin: 10px 0;
    margin-bottom: 20px;
}
.form-button {
  width: 100%;
  margin-top: 20px;
}
.login-form {
  width: 290px;
}
.forgot-password {
  margin-top: 10px;
}
.login .el-card {
  width: 340px;
  display: flex;
  justify-content: center;
  padding-top: 0;
  padding-bottom: 30px;
  text-align: center;
}
.login .el-input__prefix {
  background: rgb(238, 237, 234);
  left: 0;
  height: calc(100% - 2px);
  padding-left: 1px;
  padding-top: 1px;
  border-radius: 3px;
}
.login .el-input input {
  padding-left: 35px;
}
h2 {
  letter-spacing: 1px;
  padding-bottom: 20px;
}
.el-card.is-always-shadow {
    padding-bottom: 0;
}

.card-footer{
    margin-top: 20px;
}

</style>